import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useSubscriptionsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemActiveSubscription */
  const menuItemActiveSubscription = {
    id: "activeSubscription",
    title: t("activeSubs.activeSubscription"),
    url: baseRouteMakerForSuperAdmin(routes.ACTIVE_SUBSCRIPTION),
  };
  tempMenuGroup.push(menuItemActiveSubscription);
  /* menuItemActiveSubscription */

  /* menuItemInActiveSubscription */
  const menuItemInActiveSubscription = {
    id: "inactiveSubscription",
    title: t("activeSubs.inactiveSubscription"),
    url: baseRouteMakerForSuperAdmin(routes.INACTIVE_SUBSCRIPTION),
  };
  tempMenuGroup.push(menuItemInActiveSubscription);
  /* menuItemInActiveSubscription */

  /* menuItemInActiveSubscription */
  const menuItemSubscriptionPlan = {
    id: "subscription-plan",
    title: t("activeSubs.subscriptionPlan"),
    url: baseRouteMakerForSuperAdmin(routes.SUBSCRIPTION_PLAN),
  };
  tempMenuGroup.push(menuItemSubscriptionPlan);
  /* menuItemSubscriptionPlan */

  /* menuItemElitePremium */
  const menuItemElitePremium = {
    id: "elitePremium",
    title: t("activeSubs.elitePremium"),
    url: baseRouteMakerForSuperAdmin(routes.ELITE_PREMIUM),
  };
  tempMenuGroup.push(menuItemElitePremium);
  /* menuItemElitePremium */

  /* menuItemPremium */
  const menuItemPremium = {
    id: "premium",
    title: t("activeSubs.premium"),
    url: baseRouteMakerForSuperAdmin(routes.PREMIUM),
  };
  tempMenuGroup.push(menuItemPremium);
  /* menuItemPremium */

  /* menuItemFree */
  const menuItemFree = {
    id: "free",
    title: t("activeSubs.free"),
    url: baseRouteMakerForSuperAdmin(routes.FREE),
  };
  tempMenuGroup.push(menuItemFree);
  /* menuItemFree */

  /* menuItemAutoCredit */
  const menuItemAutoCredit = {
    id: "autoCredit",
    title: t("activeSubs.autoCredit"),
    url: baseRouteMakerForSuperAdmin(routes.AUTO_CREDIT),
  };
  tempMenuGroup.push(menuItemAutoCredit);
  /* menuItemAutoCredit */

  return tempMenuGroup;
};
